export { TSDocConfigFile } from './TSDocConfigFile';
